export default {
  serviceItem: {
    table: {
      Serialnumber: '序号',
      name: '名称',
      timeConsuming:"耗时（分钟）",
      type:"类型",
    },
  },
};
